import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgPersonGroupAdd = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M21 15v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3ZM10.23 15H4.7l-1.09 3h5.53l-.73 2H.75l2.55-7h7.66l-.73 2ZM15 15h-.48l-1.09 3H15v2h-4.43l2.55-7H15v2Z"
    />
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M7.5 3.5c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM17 3.5c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonGroupAdd;
